import { ChevronsRight, Copy } from "lucide-react";

import { Dashboard6 } from "@/components/icons";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

import { Logo } from "./Logo";
import { NavLinks } from "./NavLinks";
import { SidebarProps } from "./types";

export const DesktopSidebar = ({
  collapsed,
  toggleSidebar,
  navItems,
  isActive,
  handleLogout,
}: SidebarProps) => {
  return (
    <aside
      className={cn(
        "hidden md:flex flex-col h-screen fixed left-0 top-0 z-30 bg-[#f9f9f9] text-foreground transition-all duration-300",
        collapsed ? "w-20" : "w-80"
      )}
    >
      <div className={cn("p-8 pb-0", collapsed && "p-6")}>
        <div className="flex items-center justify-between">
          <Logo
            collapsed={collapsed}
            onClick={collapsed ? toggleSidebar : undefined}
          />
          {!collapsed && (
            <Dashboard6
              onClick={toggleSidebar}
              className="h-5 w-5 cursor-pointer text-[#767677]"
            />
          )}
        </div>
      </div>

      <div
        className={cn(
          "flex-1 overflow-y-auto pt-8 pb-6",
          collapsed ? "px-4" : "px-6"
        )}
      >
        <NavLinks
          navItems={navItems}
          isActive={isActive}
          collapsed={collapsed}
          handleLogout={handleLogout}
        />
      </div>
    </aside>
  );
};
